// Configurazione centralizzata per Google Analytics e servizi correlati
export const ANALYTICS_CONFIG = {
  // Google Analytics 4 Configuration
  GOOGLE_ANALYTICS: {
    MEASUREMENT_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-K1T5S1GT48',
    SCRIPT_URL: 'https://www.googletagmanager.com/gtag/js',
    SCRIPT_ID: 'google-analytics',
    CONSENT_MODE: 'advanced',
    DEFAULT_CONSENT: {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted'
    }
  },

  // Servizi di Marketing
  MARKETING_SERVICES: {
    // Facebook Pixel
    FACEBOOK_PIXEL: {
      PIXEL_ID: process.env.REACT_APP_FACEBOOK_PIXEL_ID || '',
      SCRIPT_URL: 'https://connect.facebook.net/en_US/fbevents.js',
      SCRIPT_ID: 'facebook-pixel',
      ENABLED: !!process.env.REACT_APP_FACEBOOK_PIXEL_ID
    },
    
    // Hotjar
    HOTJAR: {
      SITE_ID: process.env.REACT_APP_HOTJAR_SITE_ID || '',
      SCRIPT_URL: 'https://static.hotjar.com/c/hotjar-',
      SCRIPT_ID: 'hotjar',
      ENABLED: !!process.env.REACT_APP_HOTJAR_SITE_ID
    },
    
    // Google Tag Manager (se usato)
    GOOGLE_TAG_MANAGER: {
      CONTAINER_ID: process.env.REACT_APP_GTM_CONTAINER_ID || '',
      SCRIPT_URL: 'https://www.googletagmanager.com/gtm.js',
      SCRIPT_ID: 'google-tag-manager',
      ENABLED: !!process.env.REACT_APP_GTM_CONTAINER_ID
    }
  },

  // Configurazione eventi standard
  EVENTS: {
    PAGE_VIEW: 'page_view',
    VIEW_ITEM: 'view_item',
    SELECT_ITEM: 'select_item',
    ADD_TO_WISHLIST: 'add_to_wishlist',
    REMOVE_FROM_WISHLIST: 'remove_from_wishlist',
    SEARCH: 'search',
    VIEW_ITEM_LIST: 'view_item_list',
    VIEW_SELLER: 'view_seller',
    CLICK_EXTERNAL_LINK: 'click_external_link',
    LOGIN: 'login',
    SIGNUP: 'signup',
    NAVIGATION: 'navigation',
    APPLY_FILTER: 'apply_filter'
  },

  // Configurazione parametri standard
  PARAMETERS: {
    CURRENCY: 'EUR',
    ITEM_LIST_NAME: 'product_list',
    CATEGORY_LIST_NAME: 'category_products'
  },

  // Configurazione per il debug
  DEBUG: {
    ENABLED: process.env.NODE_ENV === 'development',
    LOG_PREFIX: '[Analytics]',
    TIMEOUT_MS: 100
  }
};

// Funzioni helper per la configurazione
export const getGoogleAnalyticsId = () => ANALYTICS_CONFIG.GOOGLE_ANALYTICS.MEASUREMENT_ID;

export const getConsentSettings = () => ANALYTICS_CONFIG.GOOGLE_ANALYTICS.DEFAULT_CONSENT;

export const isDebugEnabled = () => ANALYTICS_CONFIG.DEBUG.ENABLED;

export const getDebugLogPrefix = () => ANALYTICS_CONFIG.DEBUG.LOG_PREFIX;

// Funzioni helper per i servizi di marketing
export const getMarketingServicesConfig = () => ANALYTICS_CONFIG.MARKETING_SERVICES;

export const isMarketingServiceEnabled = (serviceName) => {
  const service = ANALYTICS_CONFIG.MARKETING_SERVICES[serviceName];
  return service && service.ENABLED;
}; 